import { apiRequest } from '../lib/api-client';

/** WhatsApp campaigns (Phase 117). */

export interface WhatsAppCampaign {
  id: string;
  name: string;
  channelId: string;
  templateId: string;
  values: Record<string, string[]>;
  audienceKind: 'LIST' | 'VIEW';
  audience: Record<string, unknown>;
  status: 'DRAFT' | 'SCHEDULED' | 'SENDING' | 'SENT' | 'CANCELLED' | 'FAILED';
  perMinute: number;
  scheduledAt: string | null;
  recipientsTotal: number;
  sentCount: number;
  skippedCount: number;
  failedCount: number;
  failureReason: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  createdAt: string;
}

export interface CampaignRecipient {
  entityType: 'CONTACT' | 'LEAD';
  entityId: string;
  phone: string;
  name: string | null;
  status: 'PENDING' | 'SENT' | 'SKIPPED' | 'FAILED';
  reason: string | null;
  conversationId: string | null;
  sentAt: string | null;
}

export interface WhatsAppCampaignDetail extends WhatsAppCampaign {
  recipients: CampaignRecipient[];
}

export function listCampaigns(): Promise<{ data: WhatsAppCampaign[] }> {
  return apiRequest('/v1/whatsapp/campaigns');
}

export function getCampaign(id: string): Promise<WhatsAppCampaignDetail> {
  return apiRequest(`/v1/whatsapp/campaigns/${id}`);
}

export function createCampaign(body: {
  name: string;
  channelId: string;
  templateId: string;
  values: Record<string, string[]>;
  viewId?: string;
  contactIds?: string[];
  perMinute?: number;
  scheduledAt?: string;
}): Promise<WhatsAppCampaign> {
  return apiRequest('/v1/whatsapp/campaigns', { method: 'POST', body });
}

export function scheduleCampaign(id: string, scheduledAt?: string): Promise<WhatsAppCampaign> {
  return apiRequest(`/v1/whatsapp/campaigns/${id}/schedule`, {
    method: 'POST',
    body: scheduledAt ? { scheduledAt } : {},
  });
}

export function cancelCampaign(id: string): Promise<WhatsAppCampaign> {
  return apiRequest(`/v1/whatsapp/campaigns/${id}/cancel`, { method: 'POST', body: {} });
}
